import { CalendarView } from '@/components/schedule-calendar/CalendarView'

function Dashboard() {
  return <CalendarView />
}

export default Dashboard
